import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUprightPin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 18V22M9 11.76C8.9998 12.1321 8.89581 12.4967 8.69972 12.813C8.50363 13.1292 8.22321 13.3844 7.89 13.55L6.11 14.45C5.77679 14.6156 5.49637 14.8708 5.30028 15.187C5.10419 15.5033 5.0002 15.8679 5 16.24V17C5 17.2652 5.10536 17.5196 5.29289 17.7071C5.48043 17.8946 5.73478 18 6 18H18C18.2652 18 18.5196 17.8946 18.7071 17.7071C18.8946 17.5196 19 17.2652 19 17V16.24C18.9998 15.8679 18.8958 15.5033 18.6997 15.187C18.5036 14.8708 18.2232 14.6156 17.89 14.45L16.11 13.55C15.7768 13.3844 15.4964 13.1292 15.3003 12.813C15.1042 12.4967 15.0002 12.1321 15 11.76V8C15 7.73478 15.1054 7.48043 15.2929 7.29289C15.4804 7.10536 15.7348 7 16 7C16.5304 7 17.0391 6.78929 17.4142 6.41421C17.7893 6.03914 18 5.53043 18 5C18 4.46957 17.7893 3.96086 17.4142 3.58579C17.0391 3.21071 16.5304 3 16 3H8C7.46957 3 6.96086 3.21071 6.58579 3.58579C6.21071 3.96086 6 4.46957 6 5C6 5.53043 6.21071 6.03914 6.58579 6.41421C6.96086 6.78929 7.46957 7 8 7C8.26522 7 8.51957 7.10536 8.70711 7.29289C8.89464 7.48043 9 7.73478 9 8V11.76Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgUprightPin);
export { ForwardRef as ReactComponent };
